var map = {
	"./Vector.svg": "b012",
	"./analitic.svg": "6f30",
	"./award.svg": "e005",
	"./bgAids.svg": "58b5",
	"./bgSharp.svg": "c5f9",
	"./bgStew.svg": "5376",
	"./bgVolga.svg": "9f7b",
	"./check.svg": "4a24",
	"./dagger.svg": "36d1",
	"./descBg1.svg": "561b",
	"./descBg2.svg": "0e62",
	"./descBg3.svg": "21ca",
	"./finger.svg": "4212",
	"./formBg.svg": "6ccf",
	"./google.svg": "4460",
	"./head.svg": "328a",
	"./human.svg": "cd0c",
	"./masks.svg": "7778",
	"./reviewsBg.svg": "7598",
	"./scroll.svg": "9e9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";